
import store from '../store';
import { gameActions } from '../Game/gameSlice'

export function GameOverScreen() {
    return (
        <div className='game-over-screen center'>
            <div className='text red'> YOU DIED</div>
            <div className='button-text' onClick={restartGame}> Back to Start</div>
        </div>
    )
}

function restartGame() {
    store.dispatch(gameActions.restartGame());
}